import { FC, ReactNode, useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { config } from '../config';
import { buildInfo } from '../buildInfo';

interface PosthogProviderProps {
    children: ReactNode;
}

export const PosthogProvider: FC<PosthogProviderProps> = ({ children }) => {
    const posthogKey = config.posthogConfig.posthogApiKey;
    const posthogHost = config.posthogConfig.posthogHost;
    const disableTelemetry = config.posthogConfig.disableTelemetry === 'true';

    useEffect(() => {
        if (disableTelemetry) {
            console.log('PostHog disabled by configuration');
            return;
        }

        if (posthogKey && posthogHost && typeof window !== 'undefined') {
            try {
                if (!posthog.__loaded) {
                    posthog.init(posthogKey, {
                        api_host: posthogHost,
                        ui_host: 'https://us.posthog.com',
                        capture_pageview: true,
                        capture_pageleave: true,
                        persistence: 'localStorage+cookie',
                        autocapture: true,
                        disable_session_recording: false,
                        session_recording: {
                            maskAllInputs: false,
                            maskInputOptions: {
                                password: true
                            }
                        },
                        loaded: (posthog) => {
                            posthog.register({ appVersion: buildInfo.version, appCommit: buildInfo.commit });
                            console.log(`PostHog initialized (version: ${buildInfo.version}, recording: ${posthog.sessionRecordingStarted()}, key: ...${posthogKey.slice(-5)})`);
                        }
                    });
                }
            } catch (error) {
                console.error('PostHog initialization failed:', error);
            }
        }
    }, [disableTelemetry, posthogKey, posthogHost]);

    if (!posthogKey || !posthogHost || disableTelemetry) {
        return <>{children}</>;
    }

    return (
        <PHProvider client={posthog}>
            {children}
        </PHProvider>
    );
};